import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  crearAutorizado,
  obtenerAutorizados,
  getClientes,
} from "../redux/actions/index.js";
import Swal from "sweetalert2";

export default function RegistroAutorizados() {
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [clienteId, setClienteId] = useState("");

  const dispatch = useDispatch();
  const autorizados = useSelector((state) => state.autorizados);
  const clientes = useSelector((state) => state.clientes);

  useEffect(() => {
    dispatch(getClientes());
    dispatch(obtenerAutorizados());
  }, [dispatch]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const autorizado = { nombre, telefono, email, clienteId };
      
      // Despachar la acción para crear el autorizado
      await dispatch(crearAutorizado(autorizado));
  
      // Mostrar mensaje de éxito
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Autorizado registrado exitosamente",
        showConfirmButton: false,
        timer: 1500,
      });
  
      // Limpiar los campos del formulario
      setNombre("");
      setTelefono("");
      setEmail("");
      setClienteId("");
  
      // Despachar la acción para obtener los autorizados actualizados
      dispatch(obtenerAutorizados());
    } catch (error) {  
      // Mostrar mensaje de error si ocurre un fallo
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error al registrar el autorizado",
      });
    }
  };
  

  return (
    <div className="flex flex-col lg:flex-row bg-backgroundClaro gap-6 min-h-screen h-full w-full p-6">
      {/* Formulario */}
      <div className="bg-backgroundOscuro rounded-lg p-6 lg:w-1/2 shadow-lg">
        <h1 className="text-textoClaro text-4xl font-bold mb-6 text-center">
          Crear Autorizado Nuevo
        </h1>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="nombre" className="text-textoClaro block mb-2">
              Nombre
            </label>
            <input
              id="nombre"
              type="text"
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              value={nombre}
              placeholder="Nombre del autorizado"
              onChange={(e) => setNombre(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="telefono" className="text-textoClaro block mb-2">
              Teléfono
            </label>
            <input
              id="telefono"
              type="text"
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              value={telefono}
              placeholder="Número de teléfono"
              onChange={(e) => setTelefono(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="email" className="text-textoClaro block mb-2">
              Email
            </label>
            <input
              id="email"
              type="email"
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              value={email}
              placeholder="Correo electrónico"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="clienteId" className="text-textoClaro block mb-2">
              Cliente Asociado
            </label>
            <select
              id="clienteId"
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              value={clienteId}
              onChange={(e) => setClienteId(e.target.value)}
              required
            >
              <option value="">Seleccione un cliente</option>
              {clientes.map((cliente) => (
                <option key={cliente.id} value={cliente.id}>
                  {cliente.nombre}
                </option>
              ))}
            </select>
          </div>
          <button
            type="submit"
             className="bg-green-900 w-full flex items-center justify-center my-2 p-2 rounded-md text-textoClaro font-bold text-xl hover:bg-green-600 shadow-lg shadow-green-500/50"
          >
            Registrar
          </button>
        </form>
      </div>

      {/* Lista de autorizados */}
      <div className="bg-backgroundOscuro rounded-lg p-6 lg:w-1/2 shadow-lg">
        <h2 className="text-textoClaro text-4xl font-bold mb-6">
          Lista de Autorizados
        </h2>
        <ul className="flex flex-wrap gap-4">
          {autorizados && autorizados.length > 0 ? (
          autorizados.map((autorizado) => (
            <li
              key={autorizado.id}
              className="bg-backgroundClaro p-4 rounded-lg shadow-md w-full lg:w-[calc(50%-1rem)]"
            >
              <h3 className="text-textoOscuro font-semibold">{autorizado.nombre}</h3>
              <p className="text-textoOscuro">Teléfono: {autorizado.telefono}</p>
              <p className="text-textoOscuro">Email: {autorizado.email}</p>
              <p className="text-textoOscuro">
                Cliente: {autorizado.Cliente.nombre}
              </p>
            </li>))):(
            <p className="text-textoClaro">No hay usuarios registrados.</p>
            )
          }
        </ul>
      </div>
    </div>
  );
}
